import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "sub-title" }, "分享至：", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "添加「企业成员/联系人」", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "sub-title" }, "链接分享：", -1)
const _hoisted_4 = { class: "team-share__link-content" }
const _hoisted_5 = { class: "team-share__link-text" }
const _hoisted_6 = {
  key: 0,
  class: "team-share__operate-link"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("复制")


const __default__ = {
  name: 'TeamtopShare'
}

import { h, ref, computed } from 'vue'
import { NCard, NSpace, NButton, NDropdown, useMessage } from 'naive-ui'
import { useClipboard } from '@vueuse/core'
import ShareSetting from '@teams/common/components/teamShare/setting.vue'
import useTeamShare from '@teams/common/hooks/useTeamShare'
import Icon from '@teams/common/components/icon'
// 1220版本隐藏二维码
// import { useAppDialog } from '@/components/appDialog'
import { useI18n } from 'vue-i18n'
import { useAcl } from 'vue-simple-acl'
import aclRules from '@teams/common/acl/aclRules'
// rbac设置邀请参数

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

_useCssVars(_ctx => ({
  "5154d2c9": (_unref(multipleStyle).dropDownIcon)
}))

const acl = useAcl()
const rbacSetInviteLink = computed(() => {
  return acl.can(aclRules.member_set_invite_link)
})
// rbac编辑分享设置
const rbacSetInvitationOption = computed(() => {
  return acl.can(aclRules.member_set_global_invitation_option)
})
// 通过通讯录添加成员
const rbacInviteMember = computed(() => {
  return acl.can(aclRules.member_invite_by_address_book)
})
// 通过链接邀请
const rbacInviteUrl = computed(() => {
  return acl.can(aclRules.member_invite_by_link)
})

// 国际化
const { t } = useI18n()
const tBasePrefix = ref<string>('components.dialog.dropdownOptions')

const {
  createInviteLink,
  getInviteLink,
  updateInviteLink,
  deleteInviteLink,
  inviteInfo,
  linkIsExpired
} = useTeamShare()
// 1220版本隐藏二维码
// const appDialog = useAppDialog()
const message = useMessage()
const isShowMoreOptions = ref(false)
async function initializeState() {
  await getInviteLink()
  // const link = `${location.origin}/${current.id}/invite/${inviteInfo.value?.invite_link?.key}`
}
initializeState()

const linkText = computed(() => {
  return linkIsExpired.value ? '邀请链接已失效' : inviteInfo.value.invite_url
})
const { copy: copyLink } = useClipboard({ source: linkText })

// 复制链接
const copyShareLink = () => {
  copyLink()
  message.success('复制成功')
}

// 打开二维码窗口
// 1220版本隐藏二维码
// const showQRCode = () => {
//   appDialog.show({
//     name: 'QRCode',
//     componentProps: {
//       qrCodeUrl: linkText.value,
//       qrTitle: inviteInfo.value.invite_link?.group_name
//     }
//   })
// }
// 下拉框选项
const renderCustomLabel = (preText: string, sufText: string) => {
  return () => {
    return h('div', { class: 'custom-label__content' }, [
      h('div', { class: 'content-pretext', innerHTML: preText }),
      h('div', { class: 'content-suftext', innerHTML: sufText })
    ])
  }
}
const renderIcon = () => {
  return () => {
    return h(Icon, { name: 'datePick', fill: 'transparent' })
  }
}
const options = computed(() => {
  const linkInfo = inviteInfo.value.invite_link || {}
  const expirePeriod = linkInfo.expire_period
  const threeDay = 60 * 60 * 24 * 3
  const NavOptions = [
    {
      label: renderCustomLabel(
        t(`${tBasePrefix.value}.dateDescriptPreText`),
        linkInfo.expire_period === 0
          ? t(`${tBasePrefix.value}.perpetual`)
          : t(`${tBasePrefix.value}.threeDay`)
      ),
      key: 'expirationDate',
      children: [
        {
          label: t(`${tBasePrefix.value}.threeDay`),
          key: 'threeDay',
          icon: expirePeriod === threeDay ? renderIcon() : undefined,
          operate: 'updateLink',
          value: threeDay
        },
        {
          label: t(`${tBasePrefix.value}.perpetual`),
          key: 'perpetual',
          icon: expirePeriod === 0 ? renderIcon() : undefined,
          operate: 'updateLink',
          value: 0
        }
      ]
    },
    {
      label: t(`${tBasePrefix.value}.resetTheLink`),
      key: 'resetTheLink'
    }
    /*
    ,{
      label: t(`${tBasePrefix.value}.previewSharing`),
      key: 'previewSharing'
    }
    */
  ]
  const filterNavOptions = () => {
    let rbacNavOptions = NavOptions
    !rbacSetInviteLink.value &&
      (rbacNavOptions = NavOptions.filter(
        item => item.key !== 'expirationDate' && item.key !== 'resetTheLink'
      ))
    return rbacNavOptions
  }
  return filterNavOptions()
})
// 下拉框选中
const select = async (key, option) => {
  const { operate, value } = option
  const linkInfo = inviteInfo.value.invite_link
  if (operate === 'updateLink') {
    // 永久不需重复点击
    if (value === linkInfo.expire_period && linkInfo.expire_period === 0) {
      return
    }
    await updateInviteLink(value)
  } else if (key === 'resetTheLink') {
    //   重置链接
    await deleteInviteLink()
    const { result } = await createInviteLink()
    if (result === 'ok') {
      message.success('重置成功')
    } else {
      message.error('重置失败')
    }
  } else if (key === 'previewSharing') {
    //   预览
  }
}
const multipleStyle = computed(() => ({
  dropDownIcon: isShowMoreOptions.value ? 'var(--icon-03)' : 'var(--icon-05)'
}))
// 下拉框状态改变 回调函数
const updateShowMoreOptions = () => {
  isShowMoreOptions.value = !isShowMoreOptions.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NSpace), {
    vertical: "",
    size: 30
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(NSpace), {
        vertical: "",
        size: 10
      }, {
        default: _withCtx(() => [
          _createVNode(ShareSetting, {
            readonly: !_unref(rbacSetInvitationOption)
          }, null, 8, ["readonly"])
        ]),
        _: 1
      }),
      (_unref(rbacInviteMember))
        ? (_openBlock(), _createBlock(_unref(NSpace), {
            key: 0,
            vertical: "",
            size: 10
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_unref(NCard), {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('addMember'))),
                size: "small",
                class: "team-share__add-member-card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NSpace), {
                    size: 10,
                    align: "center",
                    style: 'height: 100%;',
                    class: "team-share__add-member"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Icon), { name: "add" }),
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(rbacInviteUrl))
        ? (_openBlock(), _createBlock(_unref(NSpace), {
            key: 1,
            vertical: "",
            size: 12
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createVNode(_unref(NSpace), {
                class: "team-share__link",
                align: "stretch",
                wrap: false,
                justify: "space-between",
                style: 'height: 100%;'
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(linkText)), 1),
                    (_unref(linkText))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_unref(NSpace), { size: 12 }, {
                            default: _withCtx(() => [
                              (_unref(options).length)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass([
                  'content-operates__option',
                  { 'content-operates__option-active': isShowMoreOptions.value }
                ])
                                  }, [
                                    _createVNode(_unref(NDropdown), {
                                      options: _unref(options),
                                      placement: "bottom-start",
                                      trigger: "click",
                                      onUpdateShow: updateShowMoreOptions,
                                      onSelect: select,
                                      class: "dropdown--default teamLink-dropDown"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(Icon), { name: "moreLinkOperate" })
                                      ]),
                                      _: 1
                                    }, 8, ["options"])
                                  ], 2))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_unref(NButton), {
                    onClick: copyShareLink,
                    type: "primary",
                    width: "120",
                    disabled: _unref(linkIsExpired)
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})